<template>
  <div class="min-h-screen bg-gray-100">
    <!-- Sidebar -->
    <AdminSidebar 
      :is-open="sidebarOpen" 
      @close="sidebarOpen = false"
    />
    
    <!-- Main Content -->
    <div class="lg:pl-64">
      <!-- Top Header -->
      <AdminHeader @toggle-sidebar="sidebarOpen = !sidebarOpen" />
      
      <!-- Page Content -->
      <main class="py-6">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AdminSidebar from '@/components/admin/AdminSidebar.vue'
import AdminHeader from '@/components/admin/AdminHeader.vue'

const sidebarOpen = ref(false)
</script>
